import React from 'react';
import { IconProps } from '../Icon.types';

const ServiceIcon: React.FunctionComponent<IconProps> = ({ colourFill }) => {
  return (
    <svg width="76" height="76" viewBox="10 0 76 76" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M59.4,10.1c-0.2,0.1-1.1,0.9-3.8,3.7L52,17.3l-3-2.7c-1.6-1.5-3.1-2.8-3.2-3c-0.2-0.2-0.2-0.2-0.3-0.2
		c0,0-3.1,0.1-14.5,0.1l-14.5,0l-0.7,0.2c-0.9,0.3-1.6,0.7-2.2,1.2c-0.6,0.5-1.8,1.7-2.2,2.2c-0.6,0.8-0.9,1.6-1.2,2.7l-0.1,0.5
		l0,14.8l0,14.8l0.3,0.3l0.3,0.3l4.8,0l4.8,0l0.5,0.1c1,0.2,1.9,0.6,2.7,1.2c0.6,0.4,1.8,1.6,2.2,2.2c0.6,0.8,1,1.7,1.3,2.8l0.1,0.5
		l0,5l0,5l15,0l15,0l0.5-0.1c1.1-0.3,2-0.7,2.8-1.3c0.6-0.5,1.8-1.7,2.2-2.2c0.6-0.8,0.9-1.6,1.2-2.7l0.1-0.5l0-9.3
		c0-6.2,0-9.3,0-9.3c0,0,0-2-0.1-5.9l0-5.8l-2.9-2.7c-1.6-1.5-2.9-2.7-2.9-2.7c0,0-3.7,3.6-8.2,8.1c-6.4,6.4-8.1,8.1-8.3,8.2
		c-0.1,0.1-0.3,0.1-0.4,0.2c-0.1,0.1-0.4,0.1-0.5,0.2c-0.2,0.1-0.3,0.1-0.3,0.1c0,0-0.2,0.1-0.4,0.1c-0.2,0.1-0.4,0.2-0.5,0.2
		c-0.1,0-0.2,0.1-0.2,0.1c-0.1,0-0.1,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.1s-0.1,0-0.3,0.1c-0.3,0.1-0.5,0.2-0.6,0.2
		c-0.1,0-0.8,0.3-1.1,0.4c-0.2,0.1-0.3,0.1-0.4,0.1c0,0-0.1,0-0.2,0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.3,0.1
		c0,0-0.3,0.1-0.5,0.2c-0.7,0.2-1,0.2-1.4-0.2c-0.4-0.4-0.4-0.7-0.2-1.4c0.1-0.2,0.2-0.5,0.2-0.5c0,0,0.3-0.6,0.3-0.7c0,0,0,0,0-0.1
		c0,0,0,0,0-0.1c0,0,0-0.1,0.1-0.2c0-0.1,0.1-0.3,0.2-0.4c0.1-0.2,0.2-0.5,0.2-0.7c0.1-0.2,0.2-0.5,0.2-0.6c0.1-0.1,0.1-0.3,0.2-0.4
		c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0.1-0.2,0.1-0.4c0.1-0.2,0.2-0.4,0.2-0.5c0.1-0.2,0.2-0.6,0.2-0.7c0,0,0,0,0-0.1c0,0,0,0,0-0.1
		c0-0.1,0.1-0.3,0.2-0.6c0.2-0.3,0.5-0.7,8.1-8.3c4.4-4.4,8-8,8-8c0.1,0,1.7,1.4,1.7,1.5c0,0-3.3,3.3-7.4,7.4
		c-4.1,4-7.5,7.4-7.6,7.6l-0.2,0.2l1.2,1.2l1.2,1.2l7.6-7.6l7.6-7.6L55,20.1l-1.2-1.1l1.8-1.8l1.8-1.8l1.2,1.2l1.2,1.2L58,19.4
		l-1.7,1.7l0.2,0.2c0.1,0.1,0.5,0.5,0.9,0.8l0.7,0.6l3.4-3.4c1.9-1.9,3.5-3.5,3.5-3.6c0.2-0.3,0.2-0.6,0.1-0.9
		c-0.1-0.3-0.2-0.4-2.3-2.5c-1.2-1.2-2.3-2.2-2.4-2.3C60.1,10,59.6,10,59.4,10.1z"
          fill={colourFill}
        />
        <path
          d="M14,51.2c-0.3,0-0.5,0-0.5,0c0,0,2.4,2.5,5.4,5.6l5.4,5.6l0-0.3c0-0.2,0-1.4,0-2.8c0-2.3,0-2.5-0.1-3c-0.2-1-0.7-2-1.3-2.8
		c-0.3-0.4-0.5-0.6-0.8-0.8c-0.8-0.6-1.7-1-2.8-1.3c-0.4-0.1-0.7-0.1-1.4-0.1C15.9,51.2,14.5,51.2,14,51.2z"
          fill={colourFill}
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
